import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HistoricoInteracao } from '../../core/models/workflow.models';

@Component({
  selector: 'app-history-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './history-table.component.html',
  styleUrl: './history-table.component.scss',
})
export class HistoryTableComponent {
  @Input({ required: true }) historico: HistoricoInteracao[] = [];
}
